import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Footer from "../../Componets/Footer/Footer";
import { useComponentUtils } from "../../layout/utilscomponent.jsx";
import useFetchCommon from "../../Componets/usefetchcommon.js";
import axios from "axios";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { BASE_URL, auth_token } from "../../services/config.js";
import {
  Col,
  Container,
  Row,
  Spinner,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  FaAngleDoubleRight,
  FaPlay,
} from "react-icons/fa";
import Slider from "react-slick";
import ProgressBar from "react-bootstrap/ProgressBar";
import "react-datepicker/dist/react-datepicker.css";
import {
  SkeletonLoader,
  SkeletonLoadSlider,
} from "../skeletonLoad/skeletonthumbnail.jsx";
import CommonBannerSlider from "../../Componets/commonSlider.jsx";
import { GoChevronLeft, GoChevronRight } from "react-icons/go";
import { setIsRendered } from "../../Redux/Slice/dataRender.js";
import { setInnerPagesData, setLoadingData } from "../../Redux/Slice/innerPageDataSlice.js";
import { Helmet } from "react-helmet";
import GPTAdThree from './../videodetails/gptaddthree';
import GPTAd from "../videodetails/gptadd.jsx";
import { setThroughSeach } from "../../Redux/Slice/throughSearchSlice.js";
const Home = () => {
const vegicon = "/images/veg.png";
const nonvegicon = "/images/nonveg.png";
const verticaldefultimage = "/images/horizontaldefault.jpg";
const getaccessToken = useSelector((state) => state.accesstoken_data.accessTokenData);

  const pathname = window.location.pathname;
  // console.log("pathname", pathname); 

  localStorage.removeItem("event_title");
  localStorage.removeItem("event_genres");
  localStorage.removeItem("event_identifyunic");
  localStorage.removeItem("event_seo_url_friendly");
  localStorage.removeItem("event_seo_url");
  localStorage.removeItem("relatedmovietitle");

  localStorage.removeItem("event_first");
  localStorage.removeItem("event_secund");
  localStorage.removeItem("event_three");
  localStorage.removeItem("event_four");
  localStorage.removeItem("event_five");
  localStorage.removeItem("SublistTitle");
  const tv_shows_banner_image = "/images/tv_shows_banner.png";
  const singleGridDefault = "/images/singlegriddefault.jpg";
  const bannerDefault = "/images/etv-icon2.jpg";

  // console.log("getaccessTokensjsjsj", getaccessToken)
  let isSliding = false;
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(4);
  const [nPageSize, setNPageSize] = useState(10);
  const [homePageData, setHomePageData] = useState({});
  const [catalogListData, setCatalogListData] = useState([]);
  const [isCatalogListExist, setIsCatalogListExist] = useState([]);
  const [innerCatalogListData, setInnerCatalogListData] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [isMore, setIsmore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [continueWatchItems, setContinueWatchItems] = useState(null);
  const [continueWatchdata, setContinueWatchdata] = useState(null);
  const [isMoreAdded, setIsMoreAdded] = useState(true);
  const regionsData = useSelector((state) => state.region.regionsData);
  const [totalItemsCount, setTotalItemsCount] = useState(0);
  const [isrecordsfound, setIsrecordsfound] = useState(true);
  const [metaDescription, setMetaDescription] = useState('');

  const effectRan = useRef(false)
  const getUserId = localStorage.getItem("user_id");

const dispatch = useDispatch()

const [imageLoadedArray, setImageLoadedArray] = useState(
  new Array(catalogListData?.length).fill(false)
);



  const { sessionId } = useSelector((state) => state.auth);

  let sessionID = localStorage.getItem("session_id")
    ? localStorage.getItem("session_id")
    : sessionId;


  useEffect(() => {
    performFetch();
  }, []);

  const {loginDetails} = useSelector(state => state.signin_data)
  const isUserLoggedIn = localStorage.getItem("login_status")

const performFetch = useCallback(async () => {
  dispatch(setLoadingData({ loadingData: true }));
  if (loading) return;
  setLoading(true);

  try {
    let data = await fetchData();

    if (!data || !data.catlogData) {
      console.error('Data or catlogData is undefined.');
      setLoading(false);
      return;
    }

    let updatedData = catalogListData.length
      ? [...catalogListData, ...(data?.catlogData || [])]
      : [...(data?.catlogData || [])];

    if (!homePageData.catalog_list_items) {
      setHomePageData(data?.homePageData);
      setMetaDescription(data?.homePageData?.seo_description);
    }
    // console.log('zzzz', data)
    dispatch(setInnerPagesData({innerPagesData: data.homePageData}))
    setCatalogListData(updatedData);
    const newPage = page + 1;
    setPage(newPage);
    if (data?.homePageData?.catalog_list_items.length === 0) {
      setIsrecordsfound(false);
      setLoading(false);
      dispatch(setLoadingData({ loadingData: true }));
    }

    setTotalItemsCount(data?.homePageData?.total_items_count);
    if (data?.catlogData?.length > 0) {
      setIsrecordsfound(true);
      setLoading(false);
      dispatch(setLoadingData({ loadingData: false }));
    }

  } catch (error) {
    console.error('Error fetching data:', error);
  } finally {
    setLoading(false);
  }
}, [catalogListData]);

  



  // const handleScroll = () => {
  //   const nearBottom = window.innerHeight + window.scrollY >= document.body.offsetHeight - 500; 
  //   if (nearBottom && !loading && isrecordsfound && totalItemsCount > 0) {
  //     performFetch();
  //     window.removeEventListener("scroll", handleScroll);
  //   }
  // };


  
 const handleScroll = () => {
    const threshold = window.innerWidth <= 768 ? 400 : 100;
    if (
      catalogListData &&
      !loading  &&  isrecordsfound && homePageData.total_items_count === totalItemsCount &&
      window.innerHeight + window.scrollY >=
        document.body.offsetHeight - threshold 
    ) {
      //fetchMoreDetailsData();

      if ((page) * pageSize <= totalItemsCount) {
        performFetch(); 
      }
      // performFetch();
      window.removeEventListener("scroll", handleScroll);
  
    }
  
  
  }; 


  useEffect(() => {
    // if((page) * pageSize > homePageData.total_items_count) return;
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [catalogListData, page, totalItemsCount, loading]);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);

  useEffect(() => {
      const handleResize = () => {
          setIsMobile(window.innerWidth < 640);
      };

      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
  }, []);


  const { renderCategoryBlockWithLayoutType } = useComponentUtils(
    catalogListData,
    hasMore,
    setHasMore,
    setLoading,
    loading,
    setCatalogListData,
    innerCatalogListData,
    setInnerCatalogListData,
    homePageData
  );

  const fetchData = useFetchCommon(
    page,
    pageSize,
    nPageSize,
    setInnerCatalogListData,
    setHomePageData,
    setCatalogListData,
    setLoading,
    toast,
    setPage,
    setHasMore,
  );

  const acccessToken = getaccessToken?.access_token

  const CONTINUE_WATCHING_DETAILS = `${BASE_URL}users/${sessionID}/playlists/watchhistory/listitems.gzip?&auth_token=${auth_token}&access_token=${acccessToken}&item_language=eng&region=${regionsData?.country_code2}`;


    const { profilePicture, selectedProfile, profileName, selectedProfileId } = useSelector(
      (state) => state.manage_profile
    );


  useEffect(() => {
    if (isUserLoggedIn == "true") {
      continueWatching();
    }else {
      setContinueWatchdata([]);
      setContinueWatchItems([]);
    }
  }, [isUserLoggedIn, sessionID, selectedProfileId]);


  const [isFullscreen, setIsFullscreen] = useState(false);

useEffect(() => {
  let initialWidth = window.innerWidth;
  let initialHeight = window.innerHeight;

  const handleResize = () => {
    const currentWidth = window.innerWidth;
    const currentHeight = window.innerHeight;

    // Only reload if the width has changed, the page is not in fullscreen mode,
    // and the change is not triggered by exiting fullscreen mode.
    if (!isFullscreen && currentWidth !== initialWidth) {
      window.location.reload();
    }

    // Update the initial width and height after resize to avoid repeated reloads
    initialWidth = currentWidth;
    initialHeight = currentHeight;
  };

  const handleFullscreenChange = () => {
    // Check if any element is in fullscreen mode
    const fullscreenStatus = !!document.fullscreenElement;
    setIsFullscreen(fullscreenStatus);

    // Update initial dimensions when entering or exiting fullscreen mode to prevent reloads
    if (fullscreenStatus) {
      initialWidth = window.innerWidth;
      initialHeight = window.innerHeight;
    }
  };

  window.addEventListener('resize', handleResize);
  document.addEventListener('fullscreenchange', handleFullscreenChange);

  return () => {
    window.removeEventListener('resize', handleResize);
    document.removeEventListener('fullscreenchange', handleFullscreenChange);
  };
}, [isFullscreen]);
  


  const continueWatching = async () => {
    try {
      const response = await axios.get(CONTINUE_WATCHING_DETAILS);
      if (response?.status === 200) {
        // console.log("continuee", response?.data?.data)
        setContinueWatchdata(response?.data?.data);
        setContinueWatchItems(response?.data?.data?.items);
      }
    } catch (err) {
      if (err?.response && err?.response?.data && err?.response?.data?.error && err?.response?.data?.error?.message) {
        setErrorMessage(err?.response?.data?.error?.message);
      } 
    }
  };
  
const guestuserid = `Guest ${Math.floor(2e4 * Math.random())}`;

const SampleNextArrow = (props) => {
  const { className, onClick } = props
  return (
      <div 
          className={className}
          // className={`arrow ${className}`}
          onClick={onClick}
          style={{ cursor: "pointer" }} 
      >
        <GoChevronRight  />

      </div>
  );
}
function getPageName() {
  const path = window.location.pathname;
  const parts = path.split('/'); // Split path by '/'
  return parts[1] ?? "home"; // Return the second part after localhost/
}

const sourcetab = localStorage.getItem("selectedMenuItem");

const itemSelected = (index,listItem) => {
  dispatch(setThroughSeach({ throughSeach: false }));

  if (window && window.sdk && window.sdk.trackEvent) {
    window.sdk.trackEvent("artwork_tapped", {
      source:sourcetab?.toLowerCase(),
      video_name:listItem.title,
      event_id: 21,
      country: regionsData?.country_name,
      city: regionsData?.city_name,
      event_time: new Date().toISOString().slice(0, 19),
      tray_name: continueWatchdata?.display_title?.toLowerCase(),
      u_id: isUserLoggedIn === "true" ? getUserId : guestuserid,
      content_type: listItem?.media_type,
      position_within_tray: index+1,
      platform: "web",
      artwork_type: listItem?.media_type,
 });

  } else {
    console.error('Analytics SDK is not initialized yet.');
  }
 
 

};
const FooterCondition = () => {
  const allDataRendered = catalogListData.length > 0 && catalogListData.length === totalItemsCount;
  if (isMobile && !loading && allDataRendered) {
    return <Footer />;
  } else if (!isMobile && allDataRendered && isrecordsfound) {
    return <Footer />;
  }
  return null;
};


const description = homePageData?.seo_description || 'Default description';
const title = homePageData?.title || 'Default Title';

  return (
    <>



    <div className="banner homepage">
      {/* <Header /> */}


{
(catalogListData &&
        catalogListData.length > 0) ? (
          <CommonBannerSlider
   key="slider1" // Unique key for the slider
  sliderId="slider1" // Pass a unique identifier
     innerCatalogListData={innerCatalogListData}
     catalogListData={catalogListData}
     homePageData={homePageData}
   />
 ) :   <SkeletonLoadSlider />}

      <div className="banner-layer"></div>
    </div>

    <>


<div className="first-block">
<div className="first-slider">
<div className="title-bar">
<Container fluid className="pading-left-right-class">
  <Row>
    <Col>
      {(
        catalogListData &&
        catalogListData.length > 0 &&
        continueWatchdata !== null &&
        continueWatchdata?.total_items_count > 0 &&
        <h5>{continueWatchdata?.display_title}</h5>
      )}
    </Col>
    <Col style={{
textAlign: "end",
padding: "0px",
}}>
    {(continueWatchdata?.total_items_count >= 10 && 
      <Link
className="more-heading"
to={"/more/watch-history/all"}
>
More
<span>
<FaAngleDoubleRight />
</span>
</Link>

)}
                </Col>
              </Row>
            </Container>
          </div>
          {catalogListData && catalogListData.length > 0 && 
          <Container fluid className="left-padding-grid">
            <div className="smooth-slider continuewatch">
            <Swiper
  navigation={!isMobile ? true : false}  modules={[Pagination, Navigation]}
  slidesPerView={2}
  spaceBetween={0}
  onSlideChange={() => console.log('slide change')}
  onSwiper={(swiper) => SampleNextArrow}
  breakpoints={{
    "640": {
      slidesPerView: 3,
      spaceBetween: 11
    },
    "768": {
      slidesPerView: 4,
      spaceBetween: 11
    },
    "1024": {
      slidesPerView: isMobile ? 2 : 6.5,
      spaceBetween: 0
    }
  }}
>
  {catalogListData && catalogListData.length > 0 && continueWatchdata &&
    continueWatchItems.map((item, index) => {
      // console.log('ppspps', continueWatchdata)
      const dynamicUrl = item.seo_url;
      const ourseoUrl = dynamicUrl.startsWith("/") ? dynamicUrl : `/${dynamicUrl}`;
      let displayTitle = item.title.length > 20 ? item.title.substring(0, 20) + "..." : item.title;
      // console.log('sub_genressdsdsd', item);
      const imageSource = imageLoadedArray[index] && item?.thumbnails?.high_16_9?.url
      ? item?.thumbnails?.high_16_9?.url // Use the actual image if loaded and URL is available
      : verticaldefultimage; // Fallback to the default image
    
      const handleImageLoad = (index) => {
        setImageLoadedArray((prevState) => {
          const newState = [...prevState];
          newState[index] = true;
          return newState;
        });
      };
      
      let releaseDate = new Date(item.release_date_string);
      const day = releaseDate.getDate().toString().padStart(2, "0");
      const year = (releaseDate.getFullYear() % 100).toString().padStart(2, "0");
      const monthAbbreviation = releaseDate.toLocaleString("default", { month: "short" });
      let formattedDate = `${day} ${monthAbbreviation} ${year}`;

      return (
        <SwiperSlide key={index} >
          <Link to={`${ourseoUrl}`}  onClick={(event) => {
            localStorage.setItem("selectedItem", continueWatchdata?.display_title)
           
                            }} className="slider-card-link">
          <div className="carousel-car">
                            <div className="extra lock-icon-class cms-container cw-card">
                            
                                <div className="thumbnailMovieCard">
                                <img
  onClick={() => itemSelected(index, item)}
  className=""
  src={
    imageLoadedArray[index]
      ? imageSource // Actual image if loaded
      : verticaldefultimage // Default image before actual image loads
  }
  onLoad={() => handleImageLoad(index)}
  onError={(e) => {
    e.target.src = verticaldefultimage; // Fallback to default image if loading fails
    handleImageLoad(index); // Mark as loaded to avoid infinite reloading
  }}
  loading={!imageLoadedArray[index] ? "eager" : "lazy"} // Eager loading for default image, lazy for actual image
  width="100%"
  alt=""
  style={{
    borderRadius: "8px",
  }}
/>

{imageLoadedArray[index] && <>
                                    {item?.percentage && (
      <div
        style={{
          position: "absolute",
          bottom: "0",
          left: "5px",
          width: "95%",
          borderRadius: "0 0 8px 8px",
        }}
      >
        <ProgressBar
          variant="danger"
          now={item.percentage}
          style={{ borderRadius: "0 0 8px 8px" }}
        />

      </div>
    )}

<div className="FoodType">
{
  item?.sub_genres?.length > 0 ? (
    item.sub_genres.includes("veg") ? (
      <img
        src={vegicon}
        className=""
        loading="lazy"
        alt="Vegetarian Icon"
      />
    ) : item.sub_genres.includes("non_veg") ? (
      <img
        src={nonvegicon}
        className=""
        loading="lazy"
        alt="Non-Vegetarian Icon"
      />
    ) : null
  ) : null
}

                            </div>
   
  {!item?.access_control?.is_free && (
                                <div className="lock-postion-class"></div>
                              )}
<>
<div className="iconcame ">
                    <FaPlay />
                  </div>
  
</>
</>}
                     

                              </div>
                              {imageLoadedArray[index] && <>
                              <p className="displayTitle">  {displayTitle.length > 13 ? `${displayTitle.substring(0, 13)}...` : displayTitle}
                              {item.release_date_string ? ` | ${formattedDate}` : ""}</p>
                              </>}

                                        
                </div>
                </div>
          </Link>
        </SwiperSlide>
      );
    })
  }
</Swiper>





      

</div>
</Container>
          }
</div>
</div>

{catalogListData?.map((val, index) => {
  const layoutType = val.web_layout_type ?? val.layout_type;

  let thumbnailSize = null;
  if (layoutType === 'etv-exclusive_banner' || layoutType === 'tv_shows_banner') {
    thumbnailSize = 'web_banner';
  } else if (['episode', 'latest_episode', 'videos', 'movie_poster', 'short', 'recipe'].includes(layoutType)) {
    thumbnailSize = 'medium_16_9';
  } else if (['tv_shows', 'movies', 'top10'].includes(layoutType)) {
    thumbnailSize = 'medium_3_4';
  } else {
    thumbnailSize = 'medium_3_4';
  }

  const isBannerType = ['top_banner', 'banner', 'continue_watching'].includes(layoutType);
  
  if (val.display_title === 'Before TV') {
    // Render the GptAd component right after the specified titles
    return (
      <React.Fragment key={index}>
        {!isBannerType && (
          <>
            {renderCategoryBlockWithLayoutType(layoutType, val.display_title, val.layout_structure, thumbnailSize)}
            {/* <GPTAd />  */}
          </>
        )}
      </React.Fragment>
    );
  }
  
  return (
    !isBannerType && (
      <React.Fragment key={index}>
        {renderCategoryBlockWithLayoutType(layoutType, val.display_title, val.layout_structure, thumbnailSize)}
        {loading && 
          <div
            className="text-center mt-4"
            style={{
              position: "fixed",
              top: "60%",
              left: "50%",
              transform: "translateX(-50%)",
              zIndex: 1050,
            }}
          >
            <Spinner animation="border" variant="danger" />
          </div>
        }
      </React.Fragment>
    )
  );
})}



    </>
    
    {isMobile && !loading && <FooterCondition />}
    {!isMobile && catalogListData && catalogListData.length > 0 && <Footer />}
    </>
  );
};

export default Home;
